<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1" id="Ack">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">We would sincerely like to thank everyone who helped make this book possible. First and foremost, thank you to our dear friends Bob and Vickie Hughes for adventuring with us and taking photos of some of the places in the book; Magin and Greg Wood, who were always up for an adventure and creating illustrations for our books; authors Jim Ignasher, Joseph Citro, J.W. Ocker, Jeff Belanger and John William Tuohy; the Cavendish, Vermont Historical Society; Highlife Ski Club in Chittenden, Vermont; the Foster, Rhode Island Preservation Society; Emeritus Connecticut state archaeologist Nicholas Bellantoni; the <i>Berkshire Eagle</i>; the New England Historical Society; Terry McDermott, curator of the Wilmington, Massachusetts Town Museum; the Wilmington, Massachusetts Historical Society; Irene Morgan of the Franklin, Connecticut Historical Society; the Brattleboro, Vermont Historical Society; the Burrillville, Rhode Island Historical Society; the Cumberland Public Library; the Greenville Public Library; the <i>Observer Valley Breeze</i>; and many others who were instrumental in the making of this book who chose to remain anonymous.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?03ffba8d